;(function () {
  if (customElements.get('product-form')) return

  class ProductForm extends HTMLElement {
    constructor() {
      super()
      this.initialized = false
      this.initializeWhenReady()
    }

    initializeWhenReady() {
      if (this.hasRequiredElements()) {
        this.initializeForm()
        return
      }

      const observer = new MutationObserver((mutations, obs) => {
        if (this.hasRequiredElements()) {
          obs.disconnect()
          this.initializeForm()
        }
      })

      observer.observe(this, { childList: true, subtree: true })

      setTimeout(() => {
        observer.disconnect()
        if (!this.initialized && this.hasRequiredElements()) {
          this.initializeForm()
        }
      }, 5000)
    }

    hasRequiredElements() {
      const form = this.querySelector('form')
      return !!(form && form.querySelector('[name=id]') && this.querySelector('[type="submit"]'))
    }

    initializeForm() {
      this.form = this.querySelector('form')
      const idInput = this.form.querySelector('[name=id]')
      if (idInput) {
        idInput.disabled = false
      }

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))

      this.cart =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer')
      this.submitButton = this.querySelector('[type="submit"]')

      const cartDrawer = document.querySelector('cart-drawer')
      if (cartDrawer && this.submitButton) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog')
      }

      this.hideErrors = this.dataset.hideErrors === 'true'
      const sectionEl = this.closest('[data-section]')
      this.sectionId = sectionEl ? sectionEl.dataset.section : null

      this.initialized = true
    }

    getAddOnItems() {
      if (
        !this.sectionId ||
        typeof window.getSelectedAddOnsForSection !== 'function'
      ) {
        return []
      }
      try {
        return window.getSelectedAddOnsForSection(this.sectionId) || []
      } catch (e) {
        return []
      }
    }

    validateQuantity() {
      const quantityInput = this.form.querySelector('[name=quantity]')
      if (!quantityInput) return true

      const value = parseInt(quantityInput.value, 10)
      const min = quantityInput.min ? parseInt(quantityInput.min, 10) : null
      const max = quantityInput.max ? parseInt(quantityInput.max, 10) : null
      const step = quantityInput.step ? parseInt(quantityInput.step, 10) : 1

      let message = ''

      if (Number.isNaN(value)) {
        message =
          window.accessibilityStrings?.quantityError ||
          'Please enter a valid quantity.'
      } else if (min !== null && value < min) {
        message = (
          window.accessibilityStrings?.quantityMinimumError ||
          'Minimum quantity is [quantity].'
        ).replace('[quantity]', min)
      } else if (max !== null && value > max) {
        message = (
          window.accessibilityStrings?.quantityMaximumError ||
          'Maximum quantity is [quantity].'
        ).replace('[quantity]', max)
      } else if (step > 1 && value % step !== 0) {
        message = (
          window.accessibilityStrings?.quantityStepError ||
          'Quantity must be in increments of [quantity].'
        ).replace('[quantity]', step)
      }

      if (message) {
        this.clearQuantityErrorState()
        quantityInput.setAttribute('aria-invalid', 'true')
        this.handleErrorMessage(message, quantityInput)
        quantityInput.focus()
        return false
      }

      this.clearQuantityErrorState()
      return true
    }

    clearQuantityErrorState() {
      const quantityInput = this.form.querySelector('[name=quantity]')
      if (quantityInput) {
        quantityInput.removeAttribute('aria-invalid')
        quantityInput.removeAttribute('aria-describedby')
      }
    }

    onSubmitHandler(event) {
      event.preventDefault()

      if (this.dataset.tmfCommercialAtcBlocked === 'true') return
      try {
        if (sessionStorage.getItem('tmf_commercial_flow') === '1') {
          const eligibleHost = this.closest('[data-tmf-commercial-eligible]')
          if (eligibleHost && eligibleHost.getAttribute('data-tmf-commercial-eligible') === 'false') return
        }
      } catch (e) {}
      if (!this.submitButton) return
      if (this.submitButton.disabled) return
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return

      this.handleErrorMessage()
      this.clearQuantityErrorState()

      if (!this.validateQuantity()) {
        return
      }

      this.submitButton.setAttribute('aria-disabled', 'true')
      this.submitButton.classList.add('loading')

      const spinner = this.querySelector('.loading-overlay__spinner')
      if (spinner) spinner.classList.remove('hidden')

      const addOnItems = this.getAddOnItems()

      if (!addOnItems.length) {
        this.submitWithoutAddOns()
      } else {
        this.submitWithAddOns(addOnItems)
      }
    }

    submitWithoutAddOns() {
      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const formData = new FormData(this.form)

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        )
        formData.append('sections_url', window.location.pathname)
        this.cart.setActiveElement(document.activeElement)
      }

      config.body = formData

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message,
            })
            this.handleErrorMessage(response.description)

            const soldOutMessage =
              this.submitButton.querySelector('.sold-out-message')
            if (!soldOutMessage) return

            this.submitButton.setAttribute('aria-disabled', 'true')
            this.submitButton.querySelector('span').classList.add('hidden')
            soldOutMessage.classList.remove('hidden')
            this.error = true
            return
          }

          if (!this.cart) {
            window.location = window.routes.cart_url
            return
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
            })
          }

          this.error = false

          const quickAddModal = this.closest('quick-add-modal')
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response)
                })
              },
              { once: true }
            )
            quickAddModal.hide(true)
          } else {
            this.cart.renderContents(response)
          }
        })
        .catch(() => {
          this.error = true
          this.handleErrorMessage(
            window.accessibilityStrings?.networkError ||
              'Something went wrong. Please try again.'
          )
        })
        .finally(() => {
          this.finalizeSubmit()
        })
    }

    submitWithAddOns(addOnItems) {
      const config = fetchConfig('javascript')
      delete config.headers.Accepts

      const mainVariantId = parseInt(
        this.form.querySelector('[name=id]').value,
        10
      )
      const quantityInput = this.form.querySelector('[name=quantity]')
      const mainQuantity = quantityInput
        ? parseInt(quantityInput.value, 10) || 1
        : 1

      const items = [
        {
          id: mainVariantId,
          quantity: mainQuantity,
        },
      ].concat(addOnItems)

      const payload = {
        sections: this.cart
          ? this.cart.getSectionsToRender().map((section) => section.id).join()
          : undefined,
        sections_url: window.location.pathname,
        items: items,
      }

      config.body = JSON.stringify(payload)

      fetch(`${routes.cart_add_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description)

            const soldOutMessage =
              this.submitButton.querySelector('.sold-out-message')
            if (!soldOutMessage) return

            this.submitButton.setAttribute('aria-disabled', 'true')
            this.submitButton.querySelector('span').classList.add('hidden')
            soldOutMessage.classList.remove('hidden')
            this.error = true
            return
          }

          if (!this.cart) {
            window.location = window.routes.cart_url
            return
          }

          this.error = this.error || false

          const quickAddModal = this.closest('quick-add-modal')
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response)
                })
              },
              { once: true }
            )
            quickAddModal.hide(true)
          } else {
            this.cart.renderContents(response)
          }
        })
        .catch(() => {
          this.error = true
          this.handleErrorMessage(
            window.accessibilityStrings?.networkError ||
              'Something went wrong. Please try again.'
          )
        })
        .finally(() => {
          this.finalizeSubmit()
        })
    }

    finalizeSubmit() {
      this.submitButton.classList.remove('loading')
      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty')
      }
      if (!this.error) {
        this.submitButton.removeAttribute('aria-disabled')
      }
      const spinner = this.querySelector('.loading-overlay__spinner')
      if (spinner) spinner.classList.add('hidden')
    }

    handleErrorMessage(message = false, describedByTarget = null) {
      if (!this.initialized || this.hideErrors) return

      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper')

      if (!this.errorMessageWrapper) return

      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector('.product-form__error-message')

      if (!this.errorMessageWrapper.id) {
        this.errorMessageWrapper.id = `ProductForm-error-${this.sectionId || 'default'}`
      }

      this.errorMessageWrapper.toggleAttribute('hidden', !message)

      if (this.submitButton) {
        this.submitButton.removeAttribute('aria-describedby')
      }

      if (message) {
        this.errorMessage.textContent = message
        this.errorMessageWrapper.setAttribute('tabindex', '-1')

        if (describedByTarget) {
          describedByTarget.setAttribute(
            'aria-describedby',
            this.errorMessageWrapper.id
          )
        } else if (this.submitButton) {
          this.submitButton.setAttribute(
            'aria-describedby',
            this.errorMessageWrapper.id
          )
          this.errorMessageWrapper.focus()
        }
      } else {
        this.errorMessage.textContent = ''
        this.errorMessageWrapper.removeAttribute('tabindex')
      }
    }
  }

  customElements.define('product-form', ProductForm)
})()
